(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  exports.ResponsiveNavDropper = (function() {
    function ResponsiveNavDropper() {
      this._handleResize = bind(this._handleResize, this);
    }

    ResponsiveNavDropper.prototype.attach = function(elem, button, fudge) {
      if (button == null) {
        button = 'More';
      }
      if (fudge == null) {
        fudge = 0;
      }
      fudge += 7;
      this._addMoreMenu(elem, button);
      this._handleResize(elem, fudge);
      return $(window).resize((function(_this) {
        return function() {
          return _this._handleResize(elem, fudge);
        };
      })(this));
    };


    /*
    Handle checking the size of the element and resizing accordingly
     */

    ResponsiveNavDropper.prototype._handleResize = function(elem, fudge) {
      var diff;
      diff = this._checkSize(elem, fudge);
      if (diff > 0) {
        return this._resizeDown(elem, diff);
      } else {
        return this._resizeUp(elem, diff);
      }
    };


    /*
    Adds the "More" menu, initially hidden.
    This is where menu elements that don't fit will be moved to
     */

    ResponsiveNavDropper.prototype._addMoreMenu = function(elem, button) {
      if (elem.find('.responsive-dropper').length === 0) {
        return elem.append('<li class="dropdown nav-dropper responsive-dropper hide"> <a class="dropdown-toggle ignore-nav-handling" data-toggle="dropdown">' + button + '<b class="caret"></b> </a> <ul class="dropdown-menu pull-right"> </ul> </li>');
      }
    };


    /*
    Checks the size of element against the window size (including our fudge factor)
    and decides how much it should be allowed to adjust to fill space not taken up by siblings
     */

    ResponsiveNavDropper.prototype._checkSize = function(elem, fudge) {
      var diff, docW, sibW, sumW;
      sumW = this._sumWidth(elem.children('li:not(.hide)'));
      sibW = this._sumWidth(elem.siblings('ul'));
      docW = $(window).width();
      diff = (sumW + sibW) - (docW - fudge);
      return diff;
    };


    /*
    Handles shrinking menu items into the "More" dropdown
     */

    ResponsiveNavDropper.prototype._resizeDown = function(elem, size_to_account) {
      var groupTitle, i, j, len, lis, nestedLis, newTitle, num, page, pageTitle, ref, ref1, repaired_width, start_at, subEl, tail;
      lis = elem.children('li:not(.responsive-dropper)');
      elem.find('.responsive-dropper').removeClass('hide');
      tail = lis.length;
      repaired_width = 0;
      start_at = null;
      for (num = i = ref = tail - 1; ref <= 0 ? i <= 0 : i >= 0; num = ref <= 0 ? ++i : --i) {
        subEl = lis.eq(num);
        repaired_width += subEl.outerWidth();
        nestedLis = $.makeArray(subEl.find('li'));
        if (nestedLis.length !== 0) {
          groupTitle = subEl.find('.ignore-nav-handling').text().trim();
          ref1 = nestedLis.reverse();
          for (j = 0, len = ref1.length; j < len; j++) {
            page = ref1[j];
            page = $(page);
            pageTitle = page.text().trim();
            newTitle = groupTitle.concat(' - ', pageTitle);
            page.find('.nested-text').html(newTitle);
            page.data('nav-dropper-width', subEl.outerWidth());
            page.data('page-title', pageTitle);
            page.data('group-title', groupTitle);
            elem.find('.responsive-dropper').find('ul').prepend(page);
          }
        } else {
          subEl.data('responsive-dropper-width', subEl.outerWidth());
          elem.find('.responsive-dropper').find('ul').prepend(subEl);
        }
        if (repaired_width >= size_to_account) {
          break;
        }
      }
      return elem.find('.responsive-dropper .nav-dropper').remove();
    };


    /*
    Handles moving elements back out of the 'More' dropdown, if the
    window size has grown larger / has more room now
     */

    ResponsiveNavDropper.prototype._resizeUp = function(elem, size_to_account) {
      var group, groupHtml, groupTitle, handledNavIndexes, i, j, len, li, lis, navW, num, ref, repaired_width, siblings, subEl, w;
      lis = elem.find('.responsive-dropper .dropdown-menu').children('li');
      size_to_account = Math.abs(size_to_account);
      repaired_width = 0;
      handledNavIndexes = [];
      for (num = i = 0, ref = lis.length - 1; 0 <= ref ? i <= ref : i >= ref; num = 0 <= ref ? ++i : --i) {
        subEl = lis.eq(num);
        if (indexOf.call(handledNavIndexes, num) >= 0) {
          continue;
        }
        w = subEl.data('responsive-dropper-width');
        navW = subEl.data('nav-dropper-width');
        if (navW != null) {
          repaired_width += navW;
          if (repaired_width < size_to_account) {
            groupTitle = subEl.data('group-title');
            groupHtml = "<li class='dropdown nav-dropper nested-navigation'> <a class='dropdown-toggle ignore-nav-handling' data-toggle='dropdown'>" + groupTitle + "<b class='caret'></b> </a> <ul class='dropdown-menu pull-right'> </ul> </li>";
            groupHtml = $(groupHtml);
            group = elem.find('.responsive-dropper').before(groupHtml);
            siblings = _.filter(lis, (function(_this) {
              return function(li) {
                return $(li).data('group-title') === groupTitle;
              };
            })(this));
            for (j = 0, len = siblings.length; j < len; j++) {
              li = siblings[j];
              handledNavIndexes.push(lis.index(li));
              $(li).find('.nested-text').text($(li).data('page-title'));
            }
            groupHtml.find('ul.dropdown-menu').append(siblings);
          } else {
            break;
          }
        } else {
          if (w != null) {
            repaired_width += w;
          }
          if (repaired_width < size_to_account) {
            elem.find('.responsive-dropper').before(subEl);
          } else {
            break;
          }
        }
      }
      if (lis.length === 0) {
        return elem.find('.responsive-dropper').addClass('hide');
      }
    };

    ResponsiveNavDropper.prototype._sumWidth = function(elem) {
      var w;
      w = 0;
      elem.each(function() {
        return w += $(this).outerWidth();
      });
      return w;
    };

    return ResponsiveNavDropper;

  })();

}).call(this);
